import React from 'react'
import { useState } from "react";
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  VStack,
  SimpleGrid,
  List,
  ListItem,
  Badge,
  useBreakpointValue,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import axios from 'axios';

const Settings = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const toast = useToast();

  const handleDeactivate = () => {
    setIsModalOpen(true);
    onClose();
  };

  const handleDelete = () => {
    setIsModalOpen(false);
    // Perform account deletion logic here
    toast({
      title: "Account Deleted",
      description: "Your account has been Logged Out successfully.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    // Redirect to home page
    // Replace the 'replace' statement with your actual redirect logic
    window.location.replace("/");
  };

  const handleReset = async (e) =>{

    e.preventDefault()
    await axios.post('https://glb-api.onrender.com/api/reset/password',{}, {withCredentials:true})
    .then(() => {toast({
      title: "Reset Link Sent",
      description: "A reset password link has been sent to your registered email id.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });})
    .catch(() => {
      toast({
        title: "Some Error Occured",
        description: "Sorry, the requested process couldn't be intiated, try again later",
        status: "failure",
        duration: 5000,
        isClosable: true,
      });
    })
  }

  return (
    <>
      <Box width={"100%"} p={4}>
        <Card>
          <CardHeader bg="gray.100">
            <Heading as="h1" size="2xl">
              Settings
            </Heading>
          </CardHeader>

          <CardBody>
            <VStack gap={10}>
              <Card width={"100%"}>
                <CardHeader bg="gray.50">
                  <Heading as="h1" size="md">
                    Details
                  </Heading>
                </CardHeader>
                <CardBody>
                  <Stack spacing={4} direction={{ base: "column", md: "row" }}>
                    <FormControl>
                      <FormLabel htmlFor="first-name" fontWeight="normal">
                        First name
                      </FormLabel>
                      <Input
                        id="first-name"
                        placeholder="First name"
                        borderColor="gray.200"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel htmlFor="last-name" fontWeight="normal">
                        Last name
                      </FormLabel>
                      <Input
                        id="last-name"
                        placeholder="Last name"
                        borderColor="gray.200"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel htmlFor="date-of-birth" fontWeight="normal">
                        Date of Birth
                      </FormLabel>
                      <Input
                        type="date"
                        id="date-of-birth"
                        placeholder="Date of Birth"
                        borderColor="gray.200"
                      />
                    </FormControl>
                  </Stack>
                </CardBody>
              </Card>

              <Card width={"100%"}>
                <CardHeader bg="gray.50">
                <Flex alignItems="center" justifyContent="space-between">
                <Heading as="h1" size="md">
                  My Account
                </Heading>
                <Button
                            colorScheme="red"
                            onClick={onOpen}
                            variant="outline"
                          >
                            LOGOUT
                          </Button>
              </Flex>
                </CardHeader>
                <CardBody>
                  <Stack spacing={4} direction={{ base: "column", md: "row" }}>
                    <SimpleGrid
                      columns={{ base: 2, md: 2 }}
                      spacing={{ base: 5, md: 10 }}
                      maxWidth={{ base: "100%", md: "50%" }}
                    >
                      <List spacing={{ base: 10, md: 10 }}>
                        <ListItem>Login</ListItem>
                        <ListItem>Password</ListItem>
                        <ListItem>Account Status</ListItem>

                      </List>
                      <List spacing={{ base: 10, md: 10 }}>
                        <ListItem>Example_emailid@gmail.com</ListItem>
                        <ListItem><Button onClick={handleReset}>Reset Password</Button></ListItem>
                        <ListItem>
                          <Badge
                            variant="outline"
                            colorScheme="green"
                            fontSize={useBreakpointValue({ base: "xs", md: "xs" })}
                          >
                            Active
                          </Badge>
                        </ListItem>

                      </List>
                    </SimpleGrid>
                  </Stack>
                </CardBody>
              </Card>
            </VStack>
          </CardBody>
        </Card>
      </Box>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Log-Out Account
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to Log out of your account?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default Settings;
